<template>
  <div>
    <OverlayLoading :loading="loading" />
    <div>
      <v-row cols="12" class="justify-space-between">
        <v-col cols="12" md="9" class="">
          <div class="elevation-0 dashboard-box-showdata pa-0 justify-space-around">
            <v-row class="ml-0" justify="center" align="center" v-show="structureSubDataTest.orgchart !== []">
              <v-card
              v-for="(item, i) in structureData" :key="i"
              :width="$vuetify.breakpoint.name === 'lg' ? 'auto' : $vuetify.breakpoint.name === 'md' ? '410' : '575'"
              height="180"
              outlined
              class="mx-4 elevation-1"
            >
              <v-list-item three-line>
                <v-list-item-content>
                  <!-- <div class="text-overline mb-4"> -->
                  <v-row justify="center" align="center">
                    <v-spacer/>
                    <v-col cols="8" :class="$vuetify.breakpoint.name === 'xl' ? 'text-center mr-0' : 'text-center mr-0'" style="margin-left: 0%;">
                      <span style="font-size: 16px;">{{item.name}}</span>
                    </v-col>
                    <v-col cols="2" class="mr-1 text-right" style="margin-top: -2%;">
                      <v-icon
                        :color="`${item.color} darken-2`"
                      >
                        {{item.icon}}
                      </v-icon>
                    </v-col>
                  </v-row>
                  <v-list-item-subtitle>
                    <v-row style="height: 70px;">
                      <v-col cols="" class="text-center">
                        <v-col cols="12" class="mt-0 pt-0 mx-0" style="background-color: #EFF4FD;">
                          <span class="mx-0" style="font-weight: 500; font-size: 24px; color: #3776E9;">{{item.allMain}}</span><br>
                          <p class="mt-1" style="font-weight: 500; font-size: 14px; color: #757575;">สิทธิ์หลัก</p>
                        </v-col>
                      </v-col>
                      <v-col cols="1" class="text-center">
                        <v-divider
                          vertical
                        ></v-divider>
                      </v-col>
                      <v-col cols="" class="text-center">
                        <v-col cols="12" class="mt-0 pt-0 mx-0" style="background-color: #EFF4FD;">
                          <span class="mx-0" style="font-weight: 500; font-size: 24px; color: #3776E9;">{{item.allSub}}</span><br>
                          <p class="mt-1" style="font-weight: 500; font-size: 14px; color: #757575;">สิทธิ์ย่อย</p>
                        </v-col>
                      </v-col>
                    </v-row>
                    <!-- </div> -->
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-card>
            </v-row>
            <!-- layout right -->
            <v-row v-if="structureSubDataTest.orgchart !== []">
              <v-col cols="12">
                <div class="mt-4">
                  <v-expansion-panels
                    v-model="panel"
                    class="mb-4"
                    v-for="(item, i) in structureSubDataTest.orgchart" :key="i"
                    multiple
                  >
                    <v-expansion-panel>
                      <v-expansion-panel-header style="background-color: #E0EAFB;">
                        <td>
                          <span style="font-weight: 550;">บริษัท: </span><span class="mr-2">{{item.companyName}} </span>
                          <span style="font-weight: 550;">สายบังคับบัญชา: </span><span class="mr-2">{{item.orgChartName}} </span>
                          <span style="font-weight: 550;">ตำแหน่ง: </span><span class="mr-2">{{item.positionName}}</span>
                        </td>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <v-row>
                          <v-col cols="4">
                            <v-card
                              width="300"
                              height="150"
                              outlined
                              class="my-2 elevation-1"
                            >
                              <v-list-item three-line>
                                <v-list-item-content>
                                  <div class="text-overline mb-4">
                                    <v-row>
                                      <v-spacer/>
                                      <v-col cols="8" class="text-right">
                                        <span style="font-size: 16px;">สิทธิ์ที่มีในฝ่าย</span>
                                      </v-col>
                                      <v-col cols="3" class="mr-1 text-right" style="margin-top: -2%;">
                                        <v-icon
                                          color="primary darken-2"
                                        >
                                          mdi-account-group-outline
                                        </v-icon>
                                      </v-col>
                                    </v-row>
                                  </div>
                                  <div class="elevation-0 dashboard-box-showdata pa-0 justify-space-around" style="margin-top: -10%;">
                                      <v-row>
                                        <v-col cols="" class="text-center">
                                          <v-col cols="12" class="mt-0 pt-0 mx-0" style="background-color: #EFF4FD;">
                                            <span class="mx-0" style="font-weight: 500; font-size: 24px; color: #3776E9;">{{item.sumMainAuthen}}</span><br>
                                            <span style="font-weight: 500; font-size: 14px; color: #757575;">สิทธิ์หลัก</span>
                                          </v-col>
                                        </v-col>
                                        <v-col cols="1" class="text-center">
                                          <v-divider
                                            vertical
                                          ></v-divider>
                                        </v-col>
                                        <v-col cols="" class="text-center">
                                          <v-col cols="12" class="mt-0 pt-0 mx-0" style="background-color: #EFF4FD;">
                                            <span class="mx-0" style="font-weight: 500; font-size: 24px; color: #3776E9;">{{item.sumSubAuthen}}</span><br/>
                                            <span style="font-weight: 500; font-size: 14px; color: #757575;">สิทธิ์ย่อย</span>
                                          </v-col>
                                        </v-col>
                                      </v-row>
                                    </div>
                                </v-list-item-content>
                              </v-list-item>
                            </v-card>
                            <v-card
                              width="300"
                              height="150"
                              outlined
                              class="my-2 elevation-1"
                            >
                              <v-list-item three-line>
                                <v-list-item-content>
                                  <div class="text-overline mb-4">
                                    <v-row>
                                      <v-spacer/>
                                      <v-col cols="8" class="text-right" style="margin-left: 0%;">
                                        <span style="font-size: 16px;">สิทธิ์ที่โอน</span>
                                      </v-col>
                                      <v-col cols="3" class="mr-1 text-right" style="margin-top: -2%;">
                                        <v-icon
                                          color="yellow darken-2"
                                        >
                                          mdi-account-multiple-outline
                                        </v-icon>
                                      </v-col>
                                    </v-row>
                                  </div>
                                  <div class="elevation-0 dashboard-box-showdata pa-0 justify-space-around" style="margin-top: -10%;">
                                    <v-row>
                                      <v-col cols="" class="text-center">
                                        <v-col cols="12" class="mt-0 pt-0 mx-0" style="background-color: #EFF4FD;">
                                          <span class="mx-0" style="font-weight: 500; font-size: 24px; color: #3776E9;">{{item.mainTrnsferSum}}</span><br/>
                                          <span style="font-weight: 500; font-size: 14px; color: #757575;">สิทธิ์หลัก</span>
                                        </v-col>
                                      </v-col>
                                      <v-col cols="1" class="text-center">
                                        <v-divider
                                          vertical
                                        ></v-divider>
                                      </v-col>
                                      <v-col cols="" class="text-center">
                                        <v-col cols="12" class="mt-0 pt-0 mx-0" style="background-color: #EFF4FD;">
                                          <span class="mx-0" style="font-weight: 500; font-size: 24px; color: #3776E9;">{{item.subTrnsferSum}}</span><br/>
                                          <span style="font-weight: 500; font-size: 14px; color: #757575;">สิทธิ์ย่อย</span>
                                        </v-col>
                                      </v-col>
                                    </v-row>
                                  </div>
                                </v-list-item-content>
                              </v-list-item>
                            </v-card>
                          </v-col>
                          <!-- <v-col cols="1" class="d-flex align-start justify-start">
                            <v-divider
                              vertical
                            ></v-divider>
                          </v-col> -->
                          <!-- v-for="itemSubRole in item.mainAuthen.subAuthen.slice(0, $vuetify.breakpoint.name === 'xl' ? 3: 3)" -->
                          <v-col cols="8">
                            <v-row justify="start" align="start">
                              <v-col :cols="$vuetify.breakpoint.name === 'xl' ? 3 : 4"
                               v-for="itemSubRole in item.mainAuthen.slice(0, totalDataRole)"
                               :key="itemSubRole.id"
                               class=""
                              >
                              <v-hover v-slot="{ hover }">
                                <v-card
                                  :elevation="hover ? 4 : 0"
                                  :width="$vuetify.breakpoint.name === 'xl' ? '185' : '210'"
                                  height="105"
                                  outlined
                                  class="ma-0 elevation-2"
                                  :style="hover ? 'cursor: pointer; border: 2px solid #3776E9;' : 'cursor: pointer; border: 1px solid #C7C7C7;'"
                                  @click="editDetail(itemSubRole._id, item._id)"
                                >
                                  <v-list-item three-line>
                                    <v-list-item-content>
                                      <div class="text-overline mb-1 text-center">
                                        <span style="font-size: 12px; font-color: #333333;">{{itemSubRole.name}}</span>
                                      </div>
                                      <div class="elevation-0 dashboard-box-showdata pa-0 justify-space-around" style="margin-top: -15%;">
                                        <v-row>
                                          <v-col cols="" class="text-center">
                                            <v-col cols="12" class="mt-0 pt-0 mx-0">
                                              <v-row>
                                                <v-col cols="12">
                                                  <span class="mx-2" style="font-weight: 500; font-size: 24px; color: #3776E9;">{{itemSubRole.subAuthenSum}}</span>
                                                  <span style="font-weight: 500; font-size: 14px; color: #757575;">จำนวน</span><br>
                                                </v-col>
                                              </v-row>
                                            </v-col>
                                          </v-col>
                                        </v-row>
                                      </div>
                                    </v-list-item-content>
                                  </v-list-item>
                                </v-card>
                              </v-hover>
                              </v-col>
                            </v-row>
                            <v-row justify="center" align="center" v-if="item.mainAuthen.length > 9">
                              <v-col cols="12" class="text-center">
                                <span v-if="checkShowAllRole === false" @click="showAllData(item.mainAuthen, i)" style="color: #3776E9; cursor: pointer;">ดูเพิ่มเติม<v-icon left dark color="primary" size="">mdi-chevron-down</v-icon></span>
                                <span v-else @click="showAllData(item.mainAuthen, i)" style="color: #3776E9; cursor: pointer;">แสดงน้อยลง<v-icon left dark color="primary" size="">mdi-chevron-up</v-icon></span>
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </div>
                </v-col>
            </v-row>
            <v-row class="mt-18 mb-0" justify=center align="center" v-else style="margin-top: 200px;">
              <v-col cols="8" class="text-center">
                <img width="180" height="110" src="@/assets/icons/emp-data-icon2.png">
              </v-col>
              <v-col cols="12" class="text-center" style="margin-top: -1%;">
                <span class="" style="font-weight: bold; font-size: 14px;">ยังไม่มีข้อมูลสิทธิ์</span>
              </v-col>
            </v-row>
          </div>
        </v-col>

        <!-- <v-col cols="12" sm="12" md="3" lg="3" class=""> -->
        <v-col cols="12" md="3" class="">
          <div class="elevation-0 dashboard-box-showdata pa-0 mt-0 mb-2">
            <v-card width="450" :height="roleNearExpireList && roleNearExpireList.length <= 5 ? '450' : 'auto'" class="mx-0 pb-2">
              <v-row>
                <span class="dashboard-company-title px-6 py-3" style="color: #757575;">สิทธิ์ที่ใกล้หมดอายุ <span v-show="roleNearExpireList.length > 0" style="font-weight: bold; color: #3776E9;">({{roleNearExpireList.length}})</span> </span>
              </v-row>
              <v-row class="mx-4" v-show="roleNearExpireList.length > 0">
                <v-col cols="4">
                  <span style="font-color: black;">สิทธิ์</span>
                </v-col>
                <v-spacer></v-spacer>
                <v-col cols="8" class="text-right">
                  <span style="font-color: black;">ระยะเวลาที่เหลือ</span>
                </v-col>
              </v-row>
              <v-row justify="start" align="start" v-if="roleNearExpireList.length !== 0">
                <v-col cols="12"
                  v-for="(item, i) in roleNearExpireList.slice(0, totalDataRoleBeforeExpire)" :key="i"
                  style="margin-top: -3%;"
                >
                <v-hover v-slot="{ hover }">
                  <v-card
                    :elevation="hover ? 4 : 0"
                    width="auto"
                    height="50"
                    outlined
                    class="ma-0 mx-2 elevation-2"
                    :style="hover ? 'cursor: pointer; border: 2px solid #3776E9;' : 'cursor: pointer; border: 1px solid #C7C7C7;'"
                    @click="openDialogRoleNotExpire(item, 'nearExpire')"
                  >
                    <v-list-item>
                      <!-- <p style="font-size: 12px; font-color: #333333;">test1</p> -->
                      <v-row>
                        <v-col cols="8" class="elevation-0 dashboard-box-showdata text-left">
                        <span style="color: #333333;">{{item.name}}</span>
                      </v-col>
                      <v-col cols="4" class="elevation-0 dashboard-box-showdata text-right">
                        <v-divider
                          class="mx-3"
                          style="height: 1px;"
                          vertical
                        ></v-divider>
                        <span style="color: #D1392B;">{{item.time}} วัน</span>
                      </v-col>
                      </v-row>
                    </v-list-item>
                  </v-card>
                </v-hover>
                </v-col>
              </v-row>
              <v-row class="mt-16 mb-0" justify=center align="center" v-else>
                <v-col cols="8" class="text-center">
                  <img width="110" height="70" src="@/assets/icons/emp-data-icon2.png">
                </v-col>
                <v-col cols="12" class="text-center" style="margin-top: -1%;">
                  <span class="" style="font-weight: bold; font-size: 14px;">ยังไม่มีข้อมูลสิทธิ์ที่ใกล้หมดอายุ</span>
                </v-col>
              </v-row>
              <!-- <v-row justify="center" align="center" v-if="item.roleApprove.length > 9">
                <v-col cols="12" class="text-center">
                  <span v-if="structureSubDataTest[i].checkShowAll === false" @click="showAllData(item.roleApprove, i)" style="color: #3776E9; cursor: pointer;">ดูเพิ่มเติม<v-icon left dark color="primary" size="">mdi-chevron-down</v-icon></span>
                  <span v-else @click="showAllData(item.roleApprove, i)" style="color: #3776E9; cursor: pointer;">แสดงน้อยลง<v-icon left dark color="primary" size="">mdi-chevron-up</v-icon></span>
                </v-col>
              </v-row> -->
              <v-row justify="center" align="center" v-if="roleNearExpireList.length > 7">
                <v-col cols="12" class="text-center ml-4">
                  <span v-if="checkShowAllRoleBeforeExpire === false" @click="showAllDataRoleBeforeExpire(roleNearExpireList)" style="color: #3776E9; cursor: pointer;">ดูเพิ่มเติม<v-icon left dark color="primary" size="">mdi-chevron-down</v-icon></span>
                  <span v-else @click="showAllDataRoleBeforeExpire(roleBeforeExpire)" style="color: #3776E9; cursor: pointer;">แสดงน้อยลง<v-icon left dark color="primary" size="">mdi-chevron-up</v-icon></span>
                </v-col>
              </v-row>
            </v-card>
          </div>
          <div class="elevation-0 dashboard-box-showdata pa-0 mt-6">
            <v-card width="450" :height="roleExpireList && roleExpireList.length <= 5 ? '450' : 'auto'" class="mx-0">
              <v-row>
                <span class="dashboard-company-title px-6 py-3" style="color: #757575;">สิทธิ์ที่หมดอายุ <span v-show="roleExpireList.length > 1" style="font-weight: bold; color: #3776E9;">({{roleExpireList.length}})</span> </span>
              </v-row>
              <!-- <v-row v-for="(item, i) in structureSubDataTest.expire.slice(0, totalDataRoleBeforeExpire)" :key="i" justify="center" align="center" class="elevation-0 mx-1 mb-1" style="border: 2px solid #DCDCDC; box-sizing: border-box; border-radius: 4px;">
                <v-col cols="12" class="elevation-0 dashboard-box-showdata text-left">
                  <span style="color: #333333; cursor: pointer;" @click="openDialogRoleExpire(item)">{{item.name}}</span>
                </v-col>
              </v-row> -->
              <v-row class="mx-4" v-show="roleExpireList.length > 0">
                <v-col cols="4">
                  <span style="font-color: black;">สิทธิ์</span>
                </v-col>
                <v-spacer></v-spacer>
              </v-row>
              <v-row justify="start" align="start" v-if="roleExpireList.length !== 0">
                <v-col cols="12"
                  v-for="(item, i) in roleExpireList.slice(0, totalDataRoleExpire)" :key="i"
                  style="margin-top: -3%;"
                >
                <v-hover v-slot="{ hover }"
                >
                  <v-card
                    :elevation="hover ? 4 : 0"
                    width="auto"
                    height="50"
                    outlined
                    class="ma-0 mx-2 elevation-2"
                    :style="hover ? 'cursor: pointer; border: 2px solid #3776E9;' : 'cursor: pointer; border: 1px solid #C7C7C7;'"
                    @click="openDialogRoleNotExpire(item, 'expire')"
                  >
                    <v-list-item>
                      <!-- <p style="font-size: 12px; font-color: #333333;">test1</p> -->
                      <v-row>
                        <v-col cols="12" class="elevation-0 dashboard-box-showdata text-left">
                        <span style="color: #333333;">{{item.name}}</span>
                      </v-col>
                      </v-row>
                    </v-list-item>
                  </v-card>
                </v-hover>
                </v-col>
              </v-row>
              <v-row class="mt-16 mb-0" justify=center align="center" v-else>
                <v-col cols="8" class="text-center">
                  <img width="110" height="70" src="@/assets/icons/emp-data-icon2.png">
                </v-col>
                <v-col cols="12" class="text-center" style="margin-top: -1%;">
                  <span class="" style="font-weight: bold; font-size: 14px;">ยังไม่มีข้อมูลสิทธิ์ที่หมดอายุ</span>
                </v-col>
              </v-row>
              <v-row justify="center" align="center" v-show="roleExpireList.length > 7">
                <v-col cols="12" class="text-center">
                  <span v-if="checkShowAllRoleBeforeExpire === false" @click="showAllDataRoleExpire(roleExpireList)" style="color: #3776E9; cursor: pointer;">ดูเพิ่มเติม<v-icon left dark color="primary" size="">mdi-chevron-down</v-icon></span>
                  <span v-else @click="showAllDataRoleExpire(roleExpireList)" style="color: #3776E9; cursor: pointer;">แสดงน้อยลง<v-icon left dark color="primary" size="">mdi-chevron-up</v-icon></span>
                </v-col>
              </v-row>
            </v-card>
          </div>
        </v-col>
      </v-row>
    </div>
    <v-dialog v-model="dialogConfirm" max-width="500px">
      <v-card height="170px">
        <v-card-title class="ra-head-text-bold justify-center pa-5">ต้องการลบข้อมูลนี้ ใช่หรือไม่?</v-card-title>
        <v-card-text class="justify-center text-center">
        <span class="ra-head-text justify-center">คุณแน่ใจหรือว่าต้องการลบข้อมูลนี้</span>
        </v-card-text>
        <v-card-actions class="">
          <v-spacer></v-spacer>
          <v-btn class="ra-button1" color="#1654C6" outlined @click="dialogConfirm = false">ยกเลิก</v-btn>
          <v-btn class="ra-button1" color="#1654C6" dark @click="delRoleGroup()">ยืนยัน</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="dialogApproverCompany"
        persistent
        max-width="420"
        max-height="232">
        <v-card tile class="justify-center">
          <v-card-title class="ra-head-text-bold justify-center pa-5">ต้องการยกเลิกเอกสารนี้ใช่หรือไม่</v-card-title>
          <v-card-text class="justify-center text-center">
          <span class="ra-head-text justify-center">คุณแน่ใจหรือไม่ว่าต้องการยกเลิกเอกสารนี้</span>
          <!-- <span v-else-if="titleDialog === 'temporaryer'" class="ra-head-text justify-center">คุณแน่ใจหรือว่าต้องการลบข้อมูลผู้รักษาการคนนี้</span> -->
          <v-textarea v-model="comment" class="ml-8 mr-8" outlined rows="2" placeholder="ระบุความเห็น"></v-textarea>
          </v-card-text>
          <v-card-actions class="">
            <v-spacer></v-spacer>
            <v-btn class="ra-button1" color="#1654C6" outlined @click="dialogApproverCompany = false, comment = ''">ยกเลิก</v-btn>
            <v-btn v-if="comment === ''" class="ra-button1" color="grey" depressed disabled>ยืนยัน</v-btn>
            <v-btn v-else class="ra-button1" color="#1654C6" dark @click="updateStatusApprove('ยกเลิก')">ยืนยัน</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    <v-dialog v-model="dialogConfirmDel" max-width="500px">
      <v-card height="180px">
        <v-card-title class="ra-head-text-bold justify-center pa-5">ต้องการลบข้อมูลนี้ใช่ไหม</v-card-title>
        <v-card-text class="justify-center text-center">
        <span class="ra-head-text justify-center">คุณแน่ใจหรือไม่ว่าต้องการลบข้อมูล</span>
        <!-- <span v-else-if="titleDialog === 'temporaryer'" class="ra-head-text justify-center">คุณแน่ใจหรือว่าต้องการลบข้อมูลผู้รักษาการคนนี้</span> -->
        </v-card-text>
        <v-card-actions class="">
          <v-spacer></v-spacer>
          <v-btn class="ra-button1" color="#1654C6" outlined @click="dialogConfirmDel = false">ยกเลิก</v-btn>
          <v-btn class="ra-button1" color="#1654C6" dark @click="deleteBusiness()">ยืนยัน</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div class="text-center">
      <v-row>
        <v-snackbar
          v-model="snackbar"
          :timeout="timeout"
          :color="snackbarColor"
          text
          top
          app
        >
        <v-icon left dark small :color="snackbarColor">fa-check-circle</v-icon>
        <span :style="{ 'color': `${snackbarColor}` }">{{ text }}</span>
        </v-snackbar>
      </v-row>
      <DialogRoleNotExpire/>
      <DialogRoleExpire/>
    </div>
  </div>
</template>

<script>
import {
  getSelectTransferRole,
  fetchAllTransferRole
} from '@/API/API'
// import { OverlayLoading } from '@/components/index'
import OverlayLoading from '../../_template/OverlayLoading.vue'
import DialogRoleNotExpire from '../../_managetransferrole/_dialog/dialogRoleNotExpire'
import DialogRoleExpire from '../../_managetransferrole/_dialog/dialogRoleExpire'
import { EventBus } from '@/EventBus'
// import swal from 'sweetalert'
const moment = require('moment')
// const axios = require('axios')

export default {
  components: {
    OverlayLoading,
    DialogRoleNotExpire,
    DialogRoleExpire
  },
  data () {
    return {
      panel: [0, 2],
      snackbar: false,
      timeout: 2000,
      snackbarColor: '',
      text: '',
      approveType: '',
      dialogConfirm: false,
      dialogApproverCompany: false,
      dialogConfirmDel: false,
      delConfirmId: '',
      expanded: [],
      filter: '',
      comment: '',
      keywordShortName: '',
      keywordCompanyName: [],
      keywordGroupCompanyName: [],
      loading: false,
      perPage: 15,
      page: 1,
      total: -1,
      canSave: false,
      totalDataRoleBeforeExpire: 7,
      checkShowAllRoleBeforeExpire: false,
      totalDataRoleExpire: 7,
      checkShowAllRoleExpire: false,
      checkShowAllRole: false,
      widthShowAllRoleBeforeExpire: '',
      totalDataRole: 9,
      roleBeforeExpire: [],
      roleExpire: [],
      structureData: [],
      structureSubData: [],
      structureSubDataTest: [],
      roleExpireList: [],
      roleNearExpireList: [],
      headers: [
        {
          text: 'ลำดับ',
          align: 'center',
          value: 'no',
          width: '65',
          sortable: false
        },
        { text: 'รูปภาพ', value: 'companyImage', width: '15%' },
        { text: 'ประเภทธุรกิจ', value: 'businessType' },
        { text: 'ชื่อเต็มธุรกิจ', value: 'companyName' },
        { text: 'รูปแบบธุรกิจ', value: 'businessModelType' },
        { text: 'วันที่สร้าง', value: 'createAt' },
        { text: 'วันที่อนุมัติ', value: 'updateAt' },
        { text: 'จัดการ', value: 'data-table-expand', sortable: false, width: '130px', align: 'center fixed', class: 'column-fix' }
      ],
      mockup: [],
      selectData: [],
      roleCompanyData: [],
      approveRole: localStorage.approveRole,
      selectApproveRole: this.$store.state.user.role[1].permission
    }
  },
  async created () {
    this.url = process.env.VUE_APP_API_URL
    this.port = process.env.VUE_APP_API_PORT
    this.api = this.url + ':' + this.port
    this.tokenUser = this.$store.state.token
    this.approveRole = localStorage.approveRole
    try {
      await this.initData()
      // await this.initDataTest()
    } catch (error) {
    } finally {
      // this.loading = false
    }
  },
  beforeDestroy () {
    EventBus.$off('manageTransferRoleSearch')
    EventBus.$off('closeDialogRoleNotExpire')
  },
  mounted () {
    EventBus.$on('manageTransferRoleSearch', this.getSelect)
    EventBus.$on('closeDialogRoleNotExpire', this.initData)
  },
  methods: {
    onImgError (i) {
      this.roleCompanyData[i].failed_image = true
    },
    changePerPage (value) {
      this.perPage = value
      this.initDataTable()
    },
    changePage (value) {
      this.page = value
      this.initDataTable()
    },
    showAllDataRoleBeforeExpire (val) {
      if (this.checkShowAllRoleBeforeExpire === true) {
        this.checkShowAllRoleBeforeExpire = false
        this.totalDataRoleBeforeExpire = 7
      } else {
        this.checkShowAllRoleBeforeExpire = true
        this.totalDataRoleBeforeExpire = val.length
      }
    },
    showAllDataRoleExpire (val) {
      if (this.checkShowAllRoleExpire === true) {
        this.checkShowAllRoleExpire = false
        this.totalDataRoleExpire = 7
      } else {
        this.checkShowAllRoleExpire = true
        this.totalDataRoleExpire = val.length
      }
    },
    showAllData (val, i) {
      if (this.checkShowAllRole === true) {
        // this.structureSubDataTest[i].totalData = 6
        // this.structureSubDataTest[i].totalDataXl = 9
        this.totalDataRole = 9
        this.checkShowAllRole = false
      } else {
        // this.structureSubDataTest[i].totalData = val.length
        // this.structureSubDataTest[i].totalDataXl = val.length
        this.totalDataRole = val.length
        this.checkShowAllRole = true
      }
    },
    async getSelect (data) {
      this.filter = data
      this.keywordCompanyName = data.companyName
      this.keywordGroupCompanyName = data.groupCompany
      await this.initData()
    },
    initData () {
      this.initSelectData()
      this.initDataTable()
    },
    async initSelectData () {
      this.loading = true
      this.selectData = []
      const token = this.tokenUser
      const obj = {
        company: [],
        orgchart: [],
        mainAuthen: [],
        subAuthen: []
        // role: this.filter.role || this.approveRole
      }
      try {
        const res = await getSelectTransferRole(obj, token)
        if (res.success) {
          this.selectData = res
          EventBus.$emit('getFilterฺTransferRole', this.selectData)
          EventBus.$emit('selectGroup', res)
          // console.log(res)
        } else {
          // console.log(res)
        }
      } catch (error) {
        // alert(error)
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    async initDataTest () {
      this.structureSubDataTest = [
        {
          id: '1',
          companyName: 'วันจีโอ',
          department: 'ทรัพยากร',
          position: 'ผู้จัดการ',
          roleInDepartment: {
            primaryRole: 100,
            secondRole: 100
          },
          roleTransfer: {
            primaryRole: 50,
            secondRole: 50
          },
          roleRecive: {
            primaryRole: 10,
            secondRole: 10
          },
          roleComingExpire: [
            {
              name: 'สิทธิ์อนุมัติการลา',
              expire: '1'
            },
            {
              name: 'สิทธิ์อนุมัติการลา',
              expire: '2'
            },
            {
              name: 'สิทธิ์อนุมัติการลา',
              expire: '3'
            }
          ],
          roleExpire: [
            {
              name: 'สิทธิ์อนุมัติการลา'
            },
            {
              name: 'สิทธิ์อนุมัติการลา'
            },
            {
              name: 'สิทธิ์อนุมัติการลา'
            }
          ],
          checkShowAll: false,
          totalData: 6,
          totalDataXl: 9,
          roleApprove: []
        }
      ]
    },
    async initDataTable () {
      this.loading = true
      this.roleCompanyData = []
      const self = this
      // const temp = []
      var obj = {
        company: [this.filter.company] || [],
        orgchart: [this.filter.orgchart] || [],
        mainAuthen: [this.filter.mainAuthen] || [],
        subAuthen: [this.filter.subAuthen] || [],
        limit: this.perPage,
        page: this.page
      }
      const token = this.tokenUser

      try {
        const res = await fetchAllTransferRole(obj, token)
        if (res.success) {
          // res.result.map((el, index) => {
          //   el.companyImage = `${this.api}/api/vMonk/companys/getcompanyFileById/` + el.companyImage
          //   el.businessModelType = el.businessModelType === 'market' ? 'ธุรกิจร้านค้า' : 'นิติบุคคล'
          //   temp.push({
          //     no: index + 1,
          //     failed_image: false,
          //     ...el
          //   })
          // })
          // this.total = res?.count || -1
          // this.roleCompanyData = temp
          // self.computeData(self.roleCompanyData)
          self.structureData = []
          self.structureData.push(
            {
              id: '1',
              name: 'สิทธิ์ทั้งหมด',
              allMain: res.result.allMainAuthenSum,
              allSub: res.result.allSubAuthenSum,
              icon: 'mdi-account-group-outline',
              color: 'primary'
            },
            {
              id: '2',
              name: 'สิทธิ์ที่โอน',
              allMain: res.result.allMainTransferSum,
              allSub: res.result.allSubTransferSum,
              icon: 'mdi-account-multiple-outline',
              color: 'yellow'
            }
          )
          self.structureSubDataTest = res.result
          self.roleExpireList = res.result.expire
          self.roleNearExpireList = res.result.nearExpire
          EventBus.$emit('checkManageAuthen', res.result.oldTransfer)
        } else {
          // console.log(res)
        }
      } catch (error) {
        // alert(error)
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    openDialogRoleNotExpire (val, type) {
      EventBus.$emit('dialogRoleNotExpire', val, type)
      // EventBus.$emit('openDialogAddAprover', true, item, action, index, type)
    },
    openDialogRoleExpire (val) {
      EventBus.$emit('dialogRoleExpire', val)
    },
    editDetail (value, orgChartId) {
      this.$router.push('managetransferrole/update/' + value + '/' + orgChartId)
    },
    async computeData (item) {
      await item.map(e => {
        e.createAt = moment(e.createAt).format('DD/MM/YYYY HH:mm น.')
        e.updateAt = moment(e.updateAt).format('DD/MM/YYYY HH:mm น.')
      })
    },
    manageLineWork (data) {
      // console.log('manage line work', data)
    },
    gotocreate (title) {
      // this.$router.push('managerolecompany/create')
    },
    gotoEdit (data, title) {
      this.$router.push('managebusines/updateBusiness/' + data._id)
    }
  }
}
</script>
<style>
.border-table-employee {
  border-radius: 10px;
  border: 1px solid rgb(229, 236, 238);
}

table > tbody > tr > td.fixed:nth-last-child(1),
table > thead > tr > th.fixed:nth-last-child(1) {
  position: sticky !important;
  position: -webkit-sticky !important;
  right: 0;
  /* z-index: 9997; */
  background: white;
  /* background: transparent; */
  -webkit-box-shadow: -1px 0px 3px -1px rgba(0, 0, 0, 0.19);
  -moz-box-shadow: -1px 0px 3px -1px rgba(0, 0, 0, 0.19);
  box-shadow: -1px 0px 3px -1px rgba(0, 0, 0, 0.19);
}

table > tbody > tr:hover > td.fixed:nth-last-child(1), table > thead > tr:hover > th.fixed:nth-last-child(1) {
  background: #eeeeee;
}

table > thead > tr > th.fixed:nth-last-child(1) {
  /* z-index: 9998; */
  background-color: #F8F9FB;
}

</style>
<style>
.v-data-table {
  font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 16px;
}
.row-menu-left {
  justify-content: flex-start !important;
}
.row-menu-right {
  justify-content: flex-end !important;
}
.v-data-table tbody tr.v-data-table__expanded__content {
  box-shadow: inset 0px 4px 8px -5px rgba(50, 50, 50, 0), inset 0px -4px 8px -5px rgba(50, 50, 50, 0) !important;
}
.padding-left-90 {
  padding-left: 90px !important;
}
.table-name-row {
  display: flex;
  flex-direction: row;
}
.btn-edit-dep {
  background-color: #0370B7 !important;
  color: #fff !important;
}
.btn-del-dep {
  background-color: #da2525 !important;
  color: #fff !important;
}
</style>
